import * as React from "react";
import {ApolloError} from "@apollo/client";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Typography, Popover} from "@mui/material";

export default function BackendError(props: {error: ApolloError; children?: React.ReactNode}) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    function handleClick(event: React.MouseEvent<HTMLElement>) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    return (
        <span>
            {props.children || "Backend error"}
            <span onClick={handleClick} style={{cursor: "pointer", marginLeft: 5}}>
                <FontAwesomeIcon icon="info-circle" />
            </span>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Typography style={{padding: 10}}>{props.error.message}</Typography>
            </Popover>
        </span>
    );
}
